import styled from "@emotion/styled"
import { PTag, PText } from "@porsche-design-system/components-react"
import {
	colorSuccessFrostedSoft,
	getFocusVisibleStyle,
	spacingStaticLg,
} from "@porsche-design-system/components-react/emotion"
import type { StandardEquipmentItem } from "@slfinrtl/ui-bff-routes"
import { defineMessages, FormattedMessage } from "react-intl"

const messages = defineMessages({
	overwrittenEquipmentItem: {
		defaultMessage: "Upgraded by",
		id: "standardEquipment.overwrittenEquipmentItem",
	},
})

interface SpecialEquipmentItemProps {
	item: StandardEquipmentItem
	onClick?: (item: StandardEquipmentItem) => void
}

export const SpecialEquipmentItem = ({ item, onClick }: SpecialEquipmentItemProps) => {
	return (
		<StyledTag
			role="button"
			tabIndex={0}
			compact
			variant="success-frosted"
			title={item.name}
			onClick={() => onClick?.(item)}
		>
			<StyledText color="inherit" ellipsis>
				<FormattedMessage {...messages.overwrittenEquipmentItem} />: <u>{item.name}</u>
			</StyledText>
		</StyledTag>
	)
}

const StyledTag = styled(PTag)`
	display: block;
	align-self: start;
	cursor: pointer;
	max-width: calc(100% - ${spacingStaticLg});
	border-radius: calc(infinity * 1px);
	${getFocusVisibleStyle()};

	@media (hover: hover) and (pointer: fine) {
		&:hover {
			--p-color-success-frosted: ${colorSuccessFrostedSoft};
		}
	}
`

const StyledText = styled(PText)`
	width: 100%;
`
